// src/utils/multipartUpload.js
import axios from 'axios';

/**
 * 1️⃣ Initiate a multipart upload
 */
export async function initiateMultipartUploadPDF(baseUrl, userId, filename, fileSize) {
    try {
        const res = await axios.post(
            `${baseUrl}/pdf_multipart_upload`,
            { user_id: userId, filename, file_size_bytes: fileSize }
        );
        console.log("Response from initiateMultipartUploadPDF:", res); // { file_id, num_parts, part_size, presigned_urls }

        if (res.data.status === 400 && res.data.message === "File size is under 10MB, please use the regular upload approach since multipart upload is not needed (and will take longer)") {
            return "File size is under 10MB";
        }
        else {
            return res.data; // { file_id, num_parts, part_size, presigned_urls }
        }
    } catch (error) {
        console.log("/pdf_multipart_upload error", error);
        return null;
    }
}

export async function uploadMultipartPartsPDF(file, presignedUrls, onPartComplete) {
    console.log("Starting HERE uploadMultipartPartsPDF", presignedUrls); // { file_id, num_parts, part_size, presigned_urls }
    const total = presignedUrls.length;
    let done = 0;

    const uploads = presignedUrls.map(async ({ part_number, url, start_byte, end_byte }) => {
        // grab the exact bytes
        const slice = file.slice(start_byte, end_byte, 'application/octet-stream');
        const buffer = await slice.arrayBuffer();

        // fire a bare fetch, no axios
        const res = await fetch(url, {
            method: 'PUT',
            mode: 'cors',          // make sure CORS is on
            credentials: 'omit',   // we don’t need cookies/auth
            body: buffer
        });
        console.log(`PDF Upload part ${part_number} to ${url} returned ${res}`); // 200, 403, etc

        // If it 403s, dump the XML right into console:
        if (!res.ok) {
            const text = await res.text();
            console.error(`PDF Part ${part_number} failed with ${res.status}`, text);
            throw new Error(`PDF Upload part ${part_number} failed: see console for AWS XML`);
        }

        // success, grab the ETag
        const etag = res.headers.get('ETag');
        console.log("PDF ETag for part", part_number, etag); // ETag: "abc12345def67890" (example format, actual value will vary)
        if (!etag) {
            console.error(`PDF Part ${part_number} succeeded but no ETag returned`);
            throw new Error(`PDF No ETag on part ${part_number}`);
        }

        // bump progress
        done++;
        onPartComplete(Math.round((done / total) * 100));

        return { part_number, etag };
    });

    const results = await Promise.all(uploads);
    return results
        .sort((a, b) => a.part_number - b.part_number)
        .map(r => r.etag);
}



/**
 * 3️⃣ Complete the multipart upload on S3
 */
export async function completeMultipartUploadPDF(baseUrl, userId, fileId, etagValues) {
    const res = await axios.post(
        `${baseUrl}/complete_pdf_multipart_upload`,
        { user_id: userId, file_id: fileId, etag_values: etagValues }
    );
    console.log("response from completeMultipartUploadPDF:", res); // { status: 200, message: "Video upload complete" }
}
